import React, { useContext, useRef } from "react";
import { observer } from "mobx-react";
import { PlayerSowStoreContext } from "@state/context/sow/PlayerSowStoreContext";

import { Button } from "@components/buttons";
import { useTranslation } from "react-i18next";

export const SowFilesSection = observer(function SowFilesSection() {
	const playerSowStore = useContext(PlayerSowStoreContext);

	const filesRef = useRef<HTMLDivElement>(null);

	const { t } = useTranslation();

	if (!playerSowStore?.files) {
		return null;
	}

	if (playerSowStore?.files.length === 0) {
		return null;
	}

	return (
		<div className="card card--full u-mar--top--xsml" ref={filesRef}>
			<div className="card__body card__body--bordered u-padd--reset section">
				{playerSowStore.files.map((file, idx) => {
					let fileTypeAbrv = file.type.split("/")[1];

					if (
						fileTypeAbrv ===
						"vnd.openxmlformats-officedocument.wordprocessingml.document"
					) {
						fileTypeAbrv = "docx";
					}

					if (fileTypeAbrv === "vnd.ms-excel") {
						fileTypeAbrv = "xls";
					}

					if (
						fileTypeAbrv ===
						"vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					) {
						fileTypeAbrv = "xlsx";
					}

					return (
						<div key={file.name + idx} className="card card--file">
							<a
								href={URL.createObjectURL(file)}
								target="_blank"
								className="card--file__body"
							>
								<i
									className={
										"u-icon u-icon--xlrg u-icon--file u-icon--file--" +
										fileTypeAbrv
									}
								/>
								<div className="card--file__info">
									<div className="card--file__name u-type--sml">
										{file.name}
									</div>
									<div className="card--file__size">
										{(file.size / 1024).toFixed(2) + "KB"}
									</div>
								</div>
							</a>
							<div className="card--file__actions">
								<Button
									type="button"
									className="card--file__btn btn--sml btn--block btn--primary--inverted"
									iconLeft
									iconClassName="u-icon--sml u-icon--bin u-color--sent--danger"
									btnText={t("COMMON.DELETE")}
									onClick={() => {
										playerSowStore.removeFile(idx);
									}}
								/>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
});
